import { ElMessage } from 'element-plus'
import router from '@/routers'
import axios, { AxiosRequestConfig } from 'axios'
import { getGuid, getQueryString } from './utils'

export type ExtendAxiosRequestConfig = AxiosRequestConfig & {
  ignoreToken?: boolean
  autoPageTurning?: boolean
}

const instance = axios.create({
  withCredentials: false,
  timeout: 300000,
  headers: {},
})

instance.interceptors.request.use((request: ExtendAxiosRequestConfig) => {
  Object.assign(request!.headers!.common, {
    'sobeyhive-http-request-id': `${getGuid()}_${+new Date()}`,
  })
  const token = getQueryString('token') || window.TOKEN || localStorage.getItem('token')
  if (token && !request.ignoreToken && window.REQUIRE_AUTH) {
    Object.assign(request!.headers!.common, {
      'sobeycloud-token': token
    })
  }
  const teamcode = window.TEAMCODE || localStorage.getItem('m_current_teamcode')
  if (teamcode) {
    Object.assign(request!.headers!.common, {
      'sobeycloud-teamcode': teamcode
    })
  }
  const verify = window.VERIFY || sessionStorage.getItem('verify')
  if (verify) {
    Object.assign(request!.headers!.common, {
      'sobeycloud-framelux-verify': verify
    })
  }
  return request
})

instance.interceptors.response.use(
  (response) => {
    if (response.headers.refresh_token) {
      window.REFRESH_TOKEN = response.headers.refresh_token
      localStorage.setItem('refresh_token', window.REFRESH_TOKEN)
    }
    if (response.headers.expires_in) {
      window.EXPIRES_IN = parseInt(response.headers.expires_in) * 1000
      localStorage.setItem('expires_in', window.EXPIRES_IN + '')
    }
    if (response.headers.authorization) {
      window.TOKEN = response.headers.authorization
      localStorage.setItem('token', window.TOKEN)
      localStorage.setItem('refresh_date', +new Date() + '')
    }

    if (response.data.code && response.data.code != '0') {
      console.warn('Internal Error: ' + response.data.msg)
      //ElMessage.warning('Internal Error: ' + response.data.msg)
      return Promise.reject(response.data)
    }
    return response
  },
  async (error) => {
    console.log(error)
    if (error.response) {
      if (error.response.status === 401) {
        await router.push({
          name: 'welcome',
        })
        // 暂时使用reload来清理状态
        window.location.reload()
        return Promise.resolve(error.response.data)
      } else if (error.response.status === 500) {
      } else {
      }
      return Promise.reject(error.response.data)
    }
    return Promise.reject(error)
  }
)

export default instance
